import { render, staticRenderFns } from "./LectureViewPage.vue?vue&type=template&id=ebd21f6e"
import script from "./LectureViewPage.vue?vue&type=script&lang=js"
export * from "./LectureViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports